import snakecaseKeys from 'snakecase-keys';

import { restClient } from '../../client';
import { State } from '../../resources';

export type NonPartnerInsuranceCompanyInput = {
  stateIds: string[];
  name: string;
};

export type NonPartnerInsuranceCompany = {
  name: string;
  states: State[];
  id: string;
  creatorType: 'student' | 'admin';
  createdAt: string;
  createdBy: string;
};

export const createNonPartnerInsuranceCompany = (data: NonPartnerInsuranceCompanyInput) =>
  restClient.request<{ data: NonPartnerInsuranceCompany }>('/api/v1/higher_ed/non_partner_insurance_company', {
    method: 'POST',
    data: snakecaseKeys(data),
  });

export const getNonPartnerInsuranceCompanies = (stateId?: string) =>
  restClient.request<{ data: NonPartnerInsuranceCompany[] }>(
    '/api/v1/higher_ed/non_partner_insurance_company',
    {
      method: 'GET',
      params: snakecaseKeys({ stateId })
    }
  );

export const getNonPartnerInsuranceCompanyById = (companyId: string) =>
  restClient.request<{ data: NonPartnerInsuranceCompany }>(
    `/api/v1/higher_ed/non_partner_insurance_company/${companyId}`
  );
